import type { ArcadePersonalBest } from '../api/learning';

/**
 * Humanize API snake_case / kebab tokens without hardcoding ArcadeMode members.
 * New modes from the API surface without a frontend enum update.
 */
export function humanizeToken(token: string): string {
  return token
    .split(/[_-]+/)
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

/** Group by mode; within each mode sort timing then score for stable layout. */
export function groupPersonalBests(
  items: readonly ArcadePersonalBest[]
): { mode: string; rows: ArcadePersonalBest[] }[] {
  const byMode = new Map<string, ArcadePersonalBest[]>();
  for (const item of items) {
    const list = byMode.get(item.mode) ?? [];
    list.push(item);
    byMode.set(item.mode, list);
  }

  return [...byMode.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([mode, rows]) => ({
      mode,
      rows: [...rows].sort((left, right) => {
        const timingCmp = left.timing.localeCompare(right.timing);
        if (timingCmp !== 0) return timingCmp;
        return right.bestScore - left.bestScore;
      }),
    }));
}
